import { Plus, Search, Settings as SettingsIcon } from 'lucide-react';
import logo from '@/assets/images/logo.webp';
import { HoverTip } from '@/components/ui/HoverTip';
import { IconButton } from '@/components/ui/IconButton';
import { Shortcut } from '@/components/ui/Shortcut';
import { Tabs } from '@/components/ui/Tabs';
import { cx } from '@/cva.config';
import { useOverlays, useShellNav } from '@/providers/dashboard/ShellContext';

export const Header = () => {
  const { view, requestView } = useShellNav();
  const { openAddUrl, openPalette } = useOverlays();

  return (
    <nav className="sticky top-0 z-30 border-b border-border bg-background/85 backdrop-blur-md">
      <div className="flex h-header items-center gap-3 px-3 sm:px-4">
        <div className="flex shrink-0 items-center gap-2 pr-2">
          <div className="size-7 overflow-hidden rounded-md">
            <img
              alt="Job Goblin"
              className="-ml-10.5 h-7 w-17.5 max-w-none object-cover object-right"
              src={logo}
            />
          </div>
          <span className="hidden font-mono text-sm lg:text-base font-semibold tracking-tight sm:inline">
            Job<span className="text-accent">Goblin</span>
          </span>
        </div>
        <span className="h-5 w-px bg-border" />
        <Tabs
          items={[
            { id: 'feed', label: 'Feed' },
            { id: 'tracker', label: 'Tracker' },
          ]}
          layout="stretch"
          onChange={requestView}
          renderTrigger={({ item, trigger }) => (
            <HoverTip
              align="center"
              className="items-stretch self-stretch"
              text={
                <>
                  {item.label}{' '}
                  <Shortcut keys={`G ${item.id === 'feed' ? 'F' : 'T'}`} />
                </>
              }
            >
              {trigger}
            </HoverTip>
          )}
          value={view === 'settings' ? null : view}
        />
        <div className="flex-1" />
        <IconButton
          aria-label="Add job URL"
          className="border-border bg-transparent hover:bg-surface"
          onClick={openAddUrl}
          size="sm"
          tooltip={<>Manually add a job posting</>}
          variant="outline"
        >
          <div className="flex items-center gap-2">
            <Plus className="size-3.5" />
            <Shortcut keys="⌘K" />
          </div>
        </IconButton>
        <IconButton
          aria-label="Open command palette"
          className="border-border bg-surface/60 text-foreground-muted hover:bg-border/40 hover:text-foreground"
          onClick={openPalette}
          size="sm"
          tooltip={<>Open command palette</>}
          variant="outline"
        >
          <div className="flex items-center gap-2">
            <Search className="size-3.5" />
            <Shortcut keys="⌘K" />
          </div>
        </IconButton>
        <IconButton
          aria-label="Open settings"
          className={cx(
            'size-7 px-0',
            view === 'settings'
              ? 'border-border bg-surface text-foreground'
              : 'border-transparent text-foreground-muted hover:bg-border/40 hover:text-foreground',
          )}
          onClick={() => requestView(view === 'settings' ? 'feed' : 'settings')}
          size="sm"
          tooltip={
            <>
              Settings <Shortcut keys="G S" />
            </>
          }
          variant={view === 'settings' ? 'secondary' : 'ghost'}
        >
          <SettingsIcon className="size-4" />
        </IconButton>
      </div>
    </nav>
  );
};
